import { View } from 'react-native'
import { Skeleton } from '~/components/ui/skeleton.tsx'
import { cn } from '~/lib/utils'

export default function LoadingAsset({ className }: { className?: string }) {
  return (
    <View
      className={cn(
        'native:shadow-card w-full flex-1 flex-row gap-3 rounded-lg bg-card p-2 shadow-md shadow-primary/20',
        className
      )}>
      <Skeleton className="w-32 rounded-lg" />
      <View className="flex-1 items-start gap-4 pr-4">
        <Skeleton className="h-10 w-[75%] rounded-lg" />
        <View className="w-full flex-1 flex-row flex-wrap items-start justify-start gap-x-6 gap-y-2">
          <Skeleton className="h-7 w-[44%] rounded-lg" />
          <Skeleton className="h-7 w-[44%] rounded-lg" />
          <Skeleton className="mr-[10%] h-7 w-[34%] rounded-lg" />
          <Skeleton className="h-7 w-[34%] rounded-lg" />
        </View>
        <Skeleton className="mt-3 h-10 w-[40%] rounded-full" />
      </View>
    </View>
  )
}
